export const NUMBER_LITERAL_REGEX =
  /^-?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+-]?\d+)?$/

export const RAW_NUMBER_LITERAL_REGEX =
  /-?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+-]?\d+)?/
